export interface Customer {
  [key: string]: IndexerValueTypes;
  document_id: string;
  document_id_expiration_date?: string;
  name: string;
  surname1: string | undefined;
  surname2?: string | undefined;
  nationality: string;
  birth_country: string;
  phones: string[];
  email?: string;
  birth_date: string;
  address?: PostalAddress;
  notification_address?: PostalAddress;
  gender?: string;
  marital_status?: string;
  job?: Job;
  customer_classification?: CustomerClassificationEnum;
  require_documentation?: boolean;
  require_labor_data?: boolean;
  require_secure_payment?: boolean;
  require_address_data?: boolean;
  notification_type?: NotificationType;
}

export interface PostalAddress {
  road_type: string;
  address: string;
  number: string;
  aux?: string;
  province: string;
  postal_code: string;
  city: string;
  country?: string;
}

export interface Job {
  contract_type: string;
  monthly_income: string;
  company_name?: string;
  job_type?: string;
}

export interface City {
  postal_code: string;
  city: string;
  province: string;
}

export enum CustomerClassificationEnum {
  denied = '0',
  known = '1',
  mini = '2',
  miniPlus = '3',
  regular = '4',
  knownMiniPlus = '5',
}

export interface CustomerClassification {
  customer_classification: CustomerClassificationEnum;
  require_documentation: boolean;
  require_labor_data: boolean;
  require_secure_payment: boolean;
  require_address_data: boolean;
  require_enrichment_personal_finances?: boolean;
}

export enum NotificationType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WEB = 'WEB',
  CONTINUE = 'continue',
}

export type IndexerValueTypes =
  | number
  | string
  | string[]
  | PostalAddress
  | undefined
  | boolean
  | Job
  | CustomerClassification
  | number
  | Customer
  | null
  | Object
  | object;
